import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import { Col, Form, Input, Row } from "antd";
import type { PurchaseContractFormValues } from "../type";
import styles from "@/asserts/styles/formSection.module.less";
import { useModal } from "@/hooks/modals/useModal";
import { useFormEditable } from "../hooks/useFormEditable";
import { useTranslation } from "react-i18next";
import { useContractRecordQuery } from "../hooks/useContractRecordQuery";

type Props = {
  isMatchPendingSupplierUploadNode: boolean;
  isMatchConfirmContractNode: boolean;
};

export function ContractFileFormFields({
  isMatchPendingSupplierUploadNode,
  isMatchConfirmContractNode,
}: Props) {
  const { t } = useTranslation("contractManagement");
  const { props } = useModal("PURCHASE_CONTRACT");
  const { isFlowFinished, mode, recordId, flowStatus } = props;
  console.log({ flowStatus });

  const detail = useContractRecordQuery(recordId);

  const {
    isContractFileFormFieldsDisabled,
    isKmsContractFileNumberFormFieldsDisabled,
  } = useFormEditable();

  const showContractNumber = isMatchConfirmContractNode || isFlowFinished;

  if (
    (!isMatchPendingSupplierUploadNode &&
      !isMatchConfirmContractNode &&
      !isFlowFinished) ||
    (mode === "started" &&
      flowStatus === "已驳回" &&
      detail?.contractUploader === "澳美")
  )
    return null;

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("合同文件信息")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={24}>
            <MaterialFileFormFields
              fieldName="signedContracts"
              label={t("双方已签署合同")}
              required
              bindFlow
              accept=".pdf"
              maxCount={1}
              isCustomDisabled
              disabled={isContractFileFormFieldsDisabled}
              hiddenRemove={isContractFileFormFieldsDisabled}
            />
          </Col>

          <Col span={24}>
            <MaterialFileFormFields
              fieldName="finalContractRelatedAttachments"
              label={t("合同相关附件")}
              required={false}
              bindFlow
              isCustomDisabled
              disabled={isContractFileFormFieldsDisabled}
              hiddenRemove={isContractFileFormFieldsDisabled}
            />
          </Col>

          {showContractNumber && (
            <Col span={24}>
              <Form.Item<PurchaseContractFormValues>
                name="kmsContractNumber"
                label={t("KMS合同文件编号")}
                rules={[
                  {
                    required: true,
                    message: t("请输入KMS合同文件编号"),
                  },
                ]}
                layout="horizontal"
              >
                <Input
                  placeholder={t("请输入KMS合同文件编号")}
                  disabled={isKmsContractFileNumberFormFieldsDisabled}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
}
